import { render } from "./AccordionSection.vue?vue&type=template&id=5335d0b2&scoped=true"
import script from "./AccordionSection.vue?vue&type=script&lang=js"
export * from "./AccordionSection.vue?vue&type=script&lang=js"

import "./AccordionSection.vue?vue&type=style&index=0&id=5335d0b2&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5335d0b2"]])

export default __exports__